export enum AUTH_STEP {
  EMAIL_PASSWORD = 'emailPassword',
  OTP = 'otp',
}
